import Rule from './rule';

export default class RoundRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
    this.ruleType = 'ROUND';
    this.compile(ruleText);
  }

  compile(text) {
    const ruleParameter = text.replace(/^\s?round /i, '');
    this.args = ruleParameter.split(/\s/i).map(arg => arg.trim());
  }

  run(input) {
    if(input) {
      const result =  +input.replace(',', '.');
      if(!isNaN(result)) {
        return `${(result.toFixed(this.args[0]))}`.replace('.', ',');
      }
    }
    return input;
  }

  validate() {
    return this.args[0] >= 0 && this.args[0] <= 100 && !isNaN(this.args[0]);
  }
}
